import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiBaseService } from './api/api-base.service';

@Injectable({
  providedIn:'root'
})
export class AuthService extends ApiBaseService {

  constructor() { 
    super();
  }

  token(username: string, password: string) : Observable<any> {
    const params = new URLSearchParams();
    params.append('grant_type', 'client_credentials');
    params.append('tenant', 'NAFASP');
    params.append('username', username);
    params.append('password', password);

    return this.POSTUrlEncoded(this.getUrl('/auth/token'), params);
  }
}
